import { render, staticRenderFns } from "./bindCard-step.vue?vue&type=template&id=6266820c&scoped=true"
import script from "./bindCard-step.vue?vue&type=script&lang=js"
export * from "./bindCard-step.vue?vue&type=script&lang=js"
import style0 from "./bindCard-step.vue?vue&type=style&index=0&id=6266820c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266820c",
  null
  
)

export default component.exports